import { api } from "@/api";
import { QueryConfig, QueryResult } from "@/shared/types/base";
import { TransferenciaMetodo } from "@/shared/types/transferencia-metodo";
import { sleep } from "@/shared/utils";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";

export async function getTransferenciaMetodos(): Promise<TransferenciaMetodo[]> {
    await sleep(1000);
    const response = await api.get("monetizacion/transferencia_metodos");
    return response.data;
}

export function useGetTransferenciaMetodosQuery(queryConfig: QueryConfig<TransferenciaMetodo[]> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getTransferenciaMetodos(),
        queryKey: ["monetizacion", "transferencia_metodos"],
    })
}

export interface GetTransferenciaMetodosQueryProps {
    queryConfig?: QueryConfig<TransferenciaMetodo[]>,
    children: (queryResult: QueryResult<TransferenciaMetodo[]>) => ReactNode
}

export function GetTransferenciaMetodosQuery({
    children,
    queryConfig
}: GetTransferenciaMetodosQueryProps) {
    const queryResult = useGetTransferenciaMetodosQuery(queryConfig);
    return children && children(queryResult);
}